// @ts-nocheck
import { getToken, isSupported } from "firebase/messaging";
import { messaging } from "./firebaseConfig";
import { alertDialogAciton } from "../../../store/actions/auth";

const { VITE_APP_VAPID_KEY } = import.meta.env;

async function setupFirebaseCloudMessagingToken() {
  try {
    const doesSupportFirebaseSDK = await isSupported();

    if (!doesSupportFirebaseSDK) {
      throw new Error("Firebase SDK isn't supported");
    }

    //requesting permission using Notification API
    const permission = await Notification.requestPermission();

    if (permission == "granted") {
      const token = await getToken(messaging, {
        vapidKey: VITE_APP_VAPID_KEY,
      });

      //We can send token to server
      return token;
    } else if (permission === "denied") {
      //notifications are blocked
      // alert("You denied for the notification");
    }
  } catch (err) {
    console.warn(err);
    throw new Error("Not able to generate fcm token");
    // return null;
  }
}

function notificationSupportCheck({ auth, dispatch }) {
  if (!auth?.isFirebaseSupported) {
    dispatch(
      alertDialogAciton({
        open: true,
        title: "Error",
        message:
          "Notifications aren’t supported in this browser. Please use a modern browser like Chrome, Edge, or Firefox to enable notifications.",
      }),
    );
    return false;
  }

  if (auth?.isNotificationDenied) {
    dispatch(
      alertDialogAciton({
        open: true,
        title: "Error",
        message:
          "Please allow notifications in your browser settings before enabling notifications.",
      }),
    );
    return false;
  }
  return true;
}

export { setupFirebaseCloudMessagingToken, notificationSupportCheck };